/**
 * Recognised hash values that map directly to a tab's `data-tab` value.
 * Extra aliases let inbound links use friendly slugs ("book-a-tour") instead
 * of the internal id ("tour").
 */
const HASH_ALIASES = {
	'#tour': 'tour',
	'#book-a-tour': 'tour',
	'#book-tour': 'tour',
	'#enquiries': 'enquiries',
	'#enquiry': 'enquiries',
	'#contact': 'enquiries',
};

export const ContactTabs = {
	init() {
		document.querySelectorAll( '[data-contact-tabs]' ).forEach( ( tabsContainer ) => {
			const tabs = tabsContainer.querySelectorAll( '[data-tab]' );
			const panels = tabsContainer.closest( '.contact-page__form' )?.querySelectorAll( '[data-panel]' );

			if ( ! tabs.length || ! panels ) return;

			const activate = ( target, { syncHash = false } = {} ) => {
				const tab = Array.from( tabs ).find( ( t ) => t.getAttribute( 'data-tab' ) === target );
				if ( ! tab ) return;

				tabs.forEach( ( t ) => t.classList.remove( 'is-active' ) );
				tab.classList.add( 'is-active' );

				panels.forEach( ( p ) => {
					p.classList.toggle( 'is-active', p.getAttribute( 'data-panel' ) === target );
				} );

				if ( syncHash ) {
					// `replaceState` so the back button doesn't accumulate tab
					// switches as separate history entries.
					history.replaceState( null, '', `#${ target }` );
				}

				// Nudge embedded HubSpot iframes (and any other size-aware
				// embeds) to re-measure now that this panel is visible.
				// Cheap, harmless if nothing listens.
				window.dispatchEvent( new Event( 'resize' ) );
			};

			tabs.forEach( ( tab ) => {
				tab.addEventListener( 'click', () => {
					activate( tab.getAttribute( 'data-tab' ), { syncHash: true } );
				} );
			} );

			// Open the tab requested via URL hash on load (e.g. /contact-page/#tour)
			// — lets external CTAs deep-link straight to the Book a Tour form.
			const resolveFromHash = () => {
				const hash = ( location.hash || '' ).toLowerCase();
				return HASH_ALIASES[ hash ];
			};

			const initial = resolveFromHash();
			if ( initial ) activate( initial );

			// Respect hash changes from in-page anchors after load too.
			window.addEventListener( 'hashchange', () => {
				const t = resolveFromHash();
				if ( t ) activate( t );
			} );
		} );
	},
};
